import React, { useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { SignupPurposeCards } from "../../help/SignupPurposeCards";
import { useOnboardingPreference } from "../../help/useOnboardingPreference";

export function SignupPurposePreferences({ user }) {
  const { state, loading, saving, save, current } =
    useOnboardingPreference(user);
  const [purpose, setPurpose] = useState(null);
  useEffect(() => {
    setPurpose(state?.purpose || null);
  }, [state]);
  const submit = async () => {
    if ((await save({ purpose })) && current())
      enqueueSnackbar("Getting-started preference updated", {
        variant: "success",
      });
  };
  return (
    <Stack spacing={2} sx={{ mt: 4 }}>
      <Typography variant="h5" component="h3">
        Getting started
      </Typography>
      <Typography>
        Choose the guidance you are interested in. This does not change your
        permissions or marking settings, or restart automatic reminders.
      </Typography>
      {loading ? (
        <Typography role="status">Loading your choice…</Typography>
      ) : (
        <>
          <SignupPurposeCards
            value={purpose}
            onChange={setPurpose}
            disabled={saving}
          />
          <Stack direction="row" spacing={2}>
            <Button
              disabled={saving || !purpose}
              onClick={() => setPurpose(null)}
            >
              Clear choice
            </Button>
            <Button
              variant="contained"
              disabled={saving || purpose === (state?.purpose || null)}
              onClick={submit}
            >
              Save getting-started choice
            </Button>
          </Stack>
        </>
      )}
    </Stack>
  );
}
